






import Vue from 'vue'

export default Vue.extend({
  name: "EmployeeChangeCellRenderer",

  methods: {
    onAddEmployeeButtonClick (): void {
      // @ts-ignore
      this.params.openEmployeeDialog()
    }
  }
})
